import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/assets/icons/CloseInput.svg'


const _hoisted_1 = { class: "reportSettings" }
const _hoisted_2 = { class: "reportSettings__content" }
const _hoisted_3 = { class: "reportSettings__section" }
const _hoisted_4 = { class: "reportSettings__section" }
const _hoisted_5 = { class: "reportSettings__label" }
const _hoisted_6 = ["onUpdate:modelValue", "placeholder", "disabled"]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "reportSettings__section" }
const _hoisted_9 = { class: "reportSettings__label" }
const _hoisted_10 = { class: "reportSettings__section" }
const _hoisted_11 = { class: "reportSettings__label" }
const _hoisted_12 = { class: "reportSettings__checkboxes" }
const _hoisted_13 = {
  key: 0,
  class: "reportSettings__section"
}
const _hoisted_14 = { class: "reportSettings__label" }
const _hoisted_15 = { class: "reportSettings__checkboxes" }
const _hoisted_16 = { class: "reportSettings__actions" }
const _hoisted_17 = {
  key: 0,
  class: "reportSettings__saved"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_AddInfo = _resolveComponent("AddInfo")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_Loading, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Checkbox, {
          name: "automaticReports",
          value: _ctx.form.automaticReports,
          title: _ctx.$t('automaticReports'),
          disabled: !_ctx.canEdit,
          onChange: _ctx.toggleAutomaticReports
        }, null, 8, ["value", "title", "disabled", "onChange"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t('reportEmails')), 1),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.emails, (email, idx) => {
          return (_openBlock(), _createElementBlock("div", {
            key: idx,
            class: "reportSettings__email"
          }, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": ($event: any) => ((_ctx.form.emails[idx]) = $event),
              type: "email",
              class: "reportSettings__email-input",
              placeholder: _ctx.$t('email'),
              disabled: !_ctx.canEdit
            }, null, 8, _hoisted_6), [
              [_vModelText, _ctx.form.emails[idx]]
            ]),
            (_ctx.canEdit)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  class: "reportSettings__email-remove",
                  src: _imports_0,
                  alt: "Remove",
                  onClick: ($event: any) => (_ctx.removeEmail(idx))
                }, null, 8, _hoisted_7))
              : _createCommentVNode("", true)
          ]))
        }), 128)),
        _createVNode(_component_AddInfo, {
          title: _ctx.$t('reportEmails'),
          onClick: _ctx.addEmail
        }, null, 8, ["title", "onClick"])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.$t('frequency')), 1),
        _createVNode(_component_Dropdown, {
          class: "reportSettings__dropdown",
          "selected-option": _ctx.frequencyDropdown.selectedOption,
          options: _ctx.frequencyDropdown.options,
          disabled: !_ctx.canEdit,
          "data-testid": "selectReportFrequency",
          onSelectOption: _ctx.selectFrequency
        }, null, 8, ["selected-option", "options", "disabled", "onSelectOption"])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.$t('whatToInclude')), 1),
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_Checkbox, {
            name: "reportAllSensors",
            value: _ctx.form.include.allSensors,
            title: _ctx.$t('reportAllSensors'),
            disabled: !_ctx.canEdit,
            onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleInclude('allSensors')))
          }, null, 8, ["value", "title", "disabled"]),
          _createVNode(_component_Checkbox, {
            name: "reportRoomSensors",
            value: _ctx.form.include.roomTemperature,
            title: _ctx.$t('reportRoomSensors'),
            disabled: !_ctx.canEdit,
            onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleInclude('roomTemperature')))
          }, null, 8, ["value", "title", "disabled"]),
          _createVNode(_component_Checkbox, {
            name: "reportFridgeSensors",
            value: _ctx.form.include.fridges,
            title: _ctx.$t('reportFridgeSensors'),
            disabled: !_ctx.canEdit,
            onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleInclude('fridges')))
          }, null, 8, ["value", "title", "disabled"]),
          _createVNode(_component_Checkbox, {
            name: "reportAlarmsOnSeparatePage",
            value: _ctx.form.alarmsOnSeparatePage,
            title: _ctx.$t('reportAlarmsOnSeparatePage'),
            disabled: !_ctx.canEdit,
            onChange: _ctx.toggleAlarmsOnSeparatePage
          }, null, 8, ["value", "title", "disabled", "onChange"])
        ])
      ]),
      (_ctx.sensors.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.$t('reportIndividualSensors')), 1),
            _createElementVNode("div", _hoisted_15, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sensors, (sensor) => {
                return (_openBlock(), _createBlock(_component_Checkbox, {
                  key: sensor.id,
                  name: `reportSensor-${sensor.id}`,
                  value: _ctx.form.include.individualSensorIds.includes(sensor.id),
                  title: sensor.name,
                  disabled: !_ctx.canEdit,
                  onChange: ($event: any) => (_ctx.toggleIndividualSensor(sensor.id))
                }, null, 8, ["name", "value", "title", "disabled", "onChange"]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_16, [
        _createVNode(_component_Button, {
          class: "reportSettings__save",
          variant: "filled",
          title: _ctx.$t('save'),
          disabled: !_ctx.canSave,
          onClick: _ctx.save
        }, null, 8, ["title", "disabled", "onClick"]),
        (_ctx.saved)
          ? (_openBlock(), _createElementBlock("p", _hoisted_17, _toDisplayString(_ctx.$t('reportSettingsSaved')), 1))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}